export default {
    quadrant: {
        summary: {
            allZero: 'vse vrednosti: 0.000',
            allActive: 'vseh {count} aktivnih',
            someActive: '{active} od {total} intervalov aktivnih',
        },
    },
}
